var map = {
	"./033-bm.webp": 1262,
	"./033-cn.webp": 1263,
	"./033.webp": 1264,
	"./13-bm.webp": 1265,
	"./13-cn.webp": 1266,
	"./13.webp": 1267,
	"./3-bm.webp": 1268,
	"./3-cn.webp": 1269,
	"./3.webp": 1270,
	"./angpao-bm.webp": 1271,
	"./angpao-cn.webp": 1272,
	"./angpao.webp": 1273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1261;